module.exports = __webpack_public_path__ + "static/media/icon-calendar.8550c5e4.svg";